<div class="modal">
    <div class="header">
        <h1 class="title">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP' | translate}}</h1>
        <div class="close-button" (click)="close()"></div>
    </div>
    <div class="body">
        <ng-container *ngIf="(createGroupPending$ | async); else createGroupNotPending">
            <div class="loading-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-template #createGroupNotPending>
            <div class="section">
                <!-- <h2 class="title-section">{{ 'PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_SUBTITLE_INFORMATIONS' | translate }}</h2> -->
                <form class="form-section" [formGroup]="createGroupForm" (ngSubmit)='onSubmit()'>
                    <!-- Group name -->
                    <div class="form-input">
                        <app-smash-input type="text" borderStyle="full"
                            placeholder="{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_INPUT_PLACEHOLDER_NAME' | translate}}"
                            [error]="submitted && !!f.name.errors" formControlName="name">
                            <div *ngIf="f.name.value && !!f.name.errors" error translate>
                                PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_ERROR_INVALID_GROUP_NAME</div>
                        </app-smash-input>
                    </div>
                </form>
            </div>
        </ng-template>
    </div>
    <div class="footer">
        <button class="btn-new white" type="submit" (click)="close()"
            [disabled]="(createGroupPending$ | async)">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_BUTTON_LABEL_CANCEL' | translate}}</button>
        <button class="btn-new red" type="submit" (click)="onSubmit()"
            [disabled]="!createGroupForm.valid || (createGroupPending$ | async)">{{'PREMIUM_ADMIN_MEMBER_MODAL_ADD_GROUP_BUTTON_LABEL_CREATE_MEMBER'
            | translate}}</button>
    </div>
</div>